import { SignUp } from '@clerk/react';
import { ShieldAlert } from 'lucide-react';

export function SignUpPage() {
  return (
    <div className="min-h-screen flex">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-primary-600 p-12 flex-col justify-between">
        <div>
          <h1 className="text-3xl font-bold text-white">notlegal.chat</h1>
          <p className="text-primary-200 mt-2">Join the <span className="italic">not legal advice</span> revolution</p>
        </div>
        <div className="space-y-6">
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-primary-500 rounded-2xl flex items-center justify-center flex-shrink-0">
              <ShieldAlert className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="text-white font-semibold">Get 500 Free Tokens</h3>
              <p className="text-primary-200 text-sm mt-1">
                Your first 500 tokens are on us. Don't spend them all on "can I sue my neighbor for breathing too loud?"
              </p>
            </div>
          </div>
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-primary-500 rounded-2xl flex items-center justify-center flex-shrink-0">
              <ShieldAlert className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="text-white font-semibold">Instant Access</h3>
              <p className="text-primary-200 text-sm mt-1">
                Start getting questionable legal advice in seconds. No bar exam required.
              </p>
            </div>
          </div>
        </div>
        <p className="text-primary-300 text-sm">
          New users get 500 tokens free. Terms and conditions apply. Probably.
        </p>
      </div>

      {/* Right side - Sign Up Form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <SignUp
            appearance={{
              elements: {
                rootBox: 'mx-auto',
                card: 'shadow-soft',
              },
            }}
          />
        </div>
      </div>
    </div>
  );
}
